const stickyActions = document.querySelector('.sticky-actions');
const topAnchor = document.getElementById('page-top');

if (stickyActions && topAnchor) {
  const setHidden = (isHidden) => {
    stickyActions.classList.toggle('sticky-actions--hidden', isHidden);
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setHidden(entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0.01,
      }
    );

    observer.observe(topAnchor);
  } else {
    const onScroll = () => {
      setHidden(window.scrollY < 10);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
}
